import { Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'flowaccount-skeleton-loader-intro',
  templateUrl: './skeleton-loader-intro.component.html',
  styleUrl: './skeleton-loader-intro.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SkeletonLoaderIntroComponent {
  @Input() customCount = {
    subheading: 0,
    heading: 3,
    detail: 5,
    btn: 2,
  }
  @Input() customStyle = ''

  loopArray(no: number) {
    return new Array(no)
  }
}
